<template>
  <div class="c-profiles-form">
    <v-avatar
      :edit="true"
      :profile="profile"
      class="c-profiles-form__avatar"
      @action="editAvatar"
    ></v-avatar>

    <div class="c-profiles-form__form-groups-container">
      <div class="o-form__group">
        <div class="o-form__row">
          <label
            for="input-profile"
            class="c-profiles-form__form-label"
          >
            {{ $t('subscriber.profiles.name') }}
          </label>
        </div>
        <v-input
          id="input-profile"
          ref="profileInput"
          v-model="profile.name"
          autofocus="true"
          class="o-form__input"
          :max-length="30"
        ></v-input>
        <div
          v-if="errors.global || !isNameValid"
          class="o-badge__container"
        >
          <v-message
            :message="errors.global || $t('subscriber.profile.emptyName')"
            type="error"
            class="c-profiles-form__error-badge"
          ></v-message>
        </div>
      </div>

      <div class="o-form__group c-profiles-form__checkbox-container">
        <div class="o-form__row c-profiles-form__row">
          <v-checkbox v-model="profile.kids">
            <span class="c-profiles-form__form-label">
              {{ $t('subscriber.profiles.forChild') }}
            </span>
          </v-checkbox>
          <v-dropdown
            :position="$window.isMobileView ? 'left' : 'right'"
            :max-width="240"
          >
            <template #activator>
              <i class="o-icon o-icon--success c-profiles-form__hint"></i>
            </template>
            {{ $t('subscriber.profiles.hint') }}
          </v-dropdown>
        </div>
      </div>
    </div>

    <ui-profile-avatar-list
      v-if="avatarEdit"
      @choose="changeAvatar"
      @close="avatarEdit = false"
    ></ui-profile-avatar-list>
  </div>
</template>
<script>
  import { VCheckbox, VDropdown, VInput, VMessage } from '@/index/shared/components';
  import AvatarMixin from './avatar-mixin';

  export default {
    components: {
      VCheckbox,
      VDropdown,
      VInput,
      VMessage,
    },
    mixins: [
      AvatarMixin,
    ],
    props: {
      profile: {
        type: Object,
        default: () => ({}),
      },
      isNameValid: {
        type: Boolean,
        default: true,
      },
      errors: {
        type: Object,
        default: () => ({}),
      },
    },
    mounted() {
      this.$nextTick(() => {
        this.$refs.profileInput.$refs.input.focus();
      });
    },
  };
</script>
